import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M21.292 18.703q-.544 1.257-1.29 2.32-1.02 1.451-1.662 2.009-.995.915-2.137.94-.82.001-1.973-.47-1.154-.47-2.124-.47-1.018 0-2.185.47-1.168.472-1.888.496-1.095.047-2.184-.966-.696-.606-1.739-2.08Q2.992 19.38 2.272 17.3 1.5 15.054 1.5 12.948q0-2.413 1.044-4.158A6.1 6.1 0 0 1 4.73 6.58a5.9 5.9 0 0 1 2.955-.835q.869.002 2.285.532 1.415.532 1.813.533.3 0 2.01-.628 1.617-.58 2.733-.485 3.03.244 4.545 2.393-2.709 1.643-2.681 4.593c.016 1.531.572 2.806 1.663 3.817q.742.705 1.663 1.09-.2.58-.424 1.113M16.661.48q-.001 1.801-1.313 3.358c-1.054 1.234-2.33 1.946-3.714 1.834a4 4 0 0 1-.027-.455c0-1.152.501-2.386 1.392-3.394q.667-.765 1.696-1.273 1.028-.502 1.94-.55.027.24.026.48" }, null, -1)
  ]))]))
}
export default { render: render }